<template>
  <v-row style="padding-top:12px">
    <v-col cols="12" md="3">
      <v-toolbar>
        <v-btn :to="'/admin/tracker'">
          <v-icon left>fal fa-arrow-left</v-icon>
          Back to list
        </v-btn>
        <v-spacer></v-spacer>
      <tracker-filters></tracker-filters>
      </v-toolbar>
      <v-list>
        <v-list-item v-for="(student, index) in students" :key="'stu-' + index" :to="'/admin/tracker/' + student._id">
          <v-list-item-content>
            <v-list-item-title>{{ student.last + ', ' + student.preferred }}</v-list-item-title>
            <v-list-item-subtitle>Completed {{ student.done.sections }} / {{ sectionCount }} sections</v-list-item-subtitle>
            <v-list-item-subtitle>Completed {{ student.done.slides }} / {{ slideCount }} slides</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col cols="12" md="9">
      <v-card v-if="isLoaded">
        <v-toolbar>
          <v-toolbar-title>{{ selectedName }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn :to="'/admin/advising/student/' + trackerId">Go to Advising Profile</v-btn>
          <v-btn v-if="selectedPidm === user.pidm" @click="resetTestUser">
            <v-icon left>fal fa-undo</v-icon>
            Reset Test Account
          </v-btn>
          <v-btn v-else @click="copyUser">
            <v-icon left>fal fa-copy</v-icon>
            Copy to Test Account
          </v-btn>
        </v-toolbar>
        <v-tabs v-if="selected" v-model="tab">
          <v-tab>Section Progress</v-tab>
          <v-tab>To-Do List</v-tab>
        </v-tabs>
        <v-tabs-items v-if="selected" v-model="tab">
          <v-tab-item>
            <v-expansion-panels v-if="sections" inset>
              <template v-for="({ code, label, slides }, index) in sections">
                <tracker-panel
                  v-if="code in selected"
                  :key="'section-' + index"
                  :student-name="selectedName"
                  :code="code"
                  :label="label"
                  :slides="slides"
                  :selected="selected[code]">
                </tracker-panel>
              </template>
            </v-expansion-panels>
          </v-tab-item>
          <v-tab-item>
            <v-card v-for="({ label, items }, index) in groupedActions" :key="label" class="ma-4">
              <v-toolbar dense>
                <v-toolbar-title>{{ label }} Item{{ items.length === 1 ? '' : 's' }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu v-if="index === 0 && availableActions.length > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="success" outlined>
                      <v-icon left>fas fa-plus-circle</v-icon>
                      Add Action
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="action of availableActions" :key="action.title" @click="addAction(action)">
                      <v-list-item-content>
                        <v-list-item-title>{{ action.title }}</v-list-item-title>
                        <v-list-item-subtitle>{{ action.link }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-list>
                <v-list-item v-for="{ title, link, added } of items" :key="title">
                  <v-list-item-content>
                    <v-list-item-title>{{ title }}</v-list-item-title>
                    <v-list-item-subtitle>{{ link }}</v-list-item-subtitle>
                    <v-list-item-subtitle>Added: {{ stringFormatDate(added) }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action v-if="label === 'Dismissed'">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn v-on="on" icon @click="restoreAction(title)">
                          <v-icon>fal fa-plus-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Put back on student's active to-do list</span>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { ref, computed, watch, onMounted, onBeforeUnmount, reactive } from '@vue/composition-api'
import { formatDuration } from '@/helpers/formatters'
import { inArray } from '@/helpers/has'
import { stringFormatDate } from '../../../helpers/formatters'
export default {
  components: {
    TrackerFilters: () => import('@/components/admin/tracker/filters'),
    TrackerPanel: () => import('@/components/admin/tracker/panel')
  },
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user)
    const students = computed(() => root.$store.state.admin.students)
    const trackerId = computed(() => root.$route.params.id)
    const sectionCount = computed(() => root.$store.state.admin.sectionCount)
    const slideCount = computed(() => root.$store.state.admin.slideCount)
    const sectionDataLoaded = ref(false)
    const isLoaded = ref(false)
    const selected = ref({})
    const selectedName = ref('')
    const selectedPidm = ref('')
    const blockTracker = reactive({})
    const tab = ref(0)
    const sections = computed(() => root.$store.state.admin.sections)
    const actions = ref([])
    const groupedActions = computed(() => {
      const pending = []
      const done = []
      const dismissed = []

      for (const row of actions.value) {
        if (row.done) done.push(row)
        else if (row.dismissed) dismissed.push(row)
        else pending.push(row)
      }
      const arr = []
      if (pending.length > 0) {
        arr.push({ label: 'Pending', items: pending })
      }
      if (dismissed.length > 0) {
        arr.push({ label: 'Dismissed', items: dismissed })
      }
      if (done.length > 0) {
        arr.push({ label: 'Done', items: done })
      }
      return arr
    })
    const allActions = ref([])
    const availableActions = computed(() => allActions.value.filter(({ title }) => !actions.value.map(({ title }) => title).includes(title)))

    const trackerService = root.$feathers.service('orientation/tracker')

    const onPatchedListener = (data) => {
      if (trackerId.value === data._id) {
        loadTrackerData(data)
      }
    }
    onMounted(() => { trackerService.on('patched', onPatchedListener) })
    onBeforeUnmount(() => { trackerService.removeListener('patched', onPatchedListener) })

    onMounted(() => {
      if (!root.$store.getters.hasRole('Employee')) {
        root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have access to the admin system.' })
        root.$router.push('/')
        return
      }

      if (root.$store.state.admin.term !== '') {
        root.$store.dispatch('admin/loadSections', root.$store.state.admin.term)
        root.$store.dispatch('admin/loadStudents')
      }
    })

    watch(trackerId, () => {
      trackerService.get(trackerId.value).then((data) => {
        loadTrackerData(data)
        if (students.value.length === 0) {
          root.$store.commit('admin/updateFilter', { name: data.last + ', ' + data.preferred })
          root.$store.dispatch('admin/loadStudents')
        }
      })
    })
    async function loadTrackerData (data) {
      actions.value = data.actions
      if (root.$store.state.admin.term === '' || data.term !== root.$store.state.admin.term || students.value.length === 0) {
        let { data: termData } = await root.$feathers.service('orientation/term').find({ query: { term: data.term } })
        root.$store.commit('admin/setTerm', termData[0].term)
        root.$store.commit('admin/setTermLabel', termData[0].label)
        root.$store.commit('admin/updateFilter', { name: data.last + ', ' + data.preferred, excludeTests: false })
        await root.$store.dispatch('admin/loadStudents')
        await root.$store.dispatch('admin/loadSections', root.$store.state.admin.term)
      }
      const completedSections = data.sections.filter(({ status }) => status === 'Complete').map(({ section }) => section)
      const aggregate = [
        { $match: { term: data.term, code: { $in: completedSections } } },
        { $unwind: '$actions' },
        { $project: {
          title: '$actions.title',
          link: '$actions.link',
          isPlacementTest: '$actions.isPlacementTest',
          dialogText: '$actions.dialogText'
        } }
      ]
      root.$feathers.service('orientation/section').find({ query: { aggregate } }).then(({ data }) => {
        allActions.value = data
      })
      selectedName.value = data.preferred + ' ' + data.last
      selectedPidm.value = data.pidm
      let obj = {}
      let tracker = {}
      for (const { section, status, highSlide } of data.sections) {
        tracker[section] = { status, highSlide }
      }
      let blockTracker = {}
      for (const { section, block, complete, items, video, quiz } of data.blocks) {
        if (!(section in blockTracker)) blockTracker[section] = {}
        blockTracker[section][block] = { complete, items, video, quiz }
      }
      for (const { code: section, slides } of sections.value) {
        obj[section] = {
          status: section in tracker ? tracker[section].status : 'Locked',
          slides: []
        }
        for (let i = 0; i < slides.length; i++) {
          const { name, primary, secondary } = slides[i]
          let slide = {
            name,
            seen: section in tracker && tracker[section].highSlide >= i + 1,
            types: [],
            blocks: []
          }
          for (const { name, type, id } of primary) {
            if (!inArray(type, slide.types)) slide.types.push(type)
            if (section in blockTracker && id in blockTracker[section]) {
              slide.blocks.push({ id, name, type, ...blockTracker[section][id] })
            }
          }
          for (const { name, type, id } of secondary) {
            if (!inArray(type, slide.types)) slide.types.push(type)
            if (section in blockTracker && id in blockTracker[section]) {
              slide.blocks.push({ id, name, type, ...blockTracker[section][id] })
            }
          }
          obj[section].slides.push(slide)
        }
      }
      selected.value = obj
      isLoaded.value = true
    }

    function resetTestUser () {
      root.$feathers.service('orientation/section').find({ query: { term: root.$store.state.admin.term, order: 1 } }).then(({ data }) => {
        const section = data[0].code
        trackerService.create({
          pidm: user.value.pidm,
          preferred: user.value.preferred,
          last: user.value.last,
          username: user.value.username,
          email: user.value.email,
          isTest: true,
          term: root.$store.state.admin.term,
          sections: [{
            section,
            status: 'Ready'
          }],
          blocks: [],
          actions: []
        }).then(() => {
          root.$store.dispatch('loadTracker')
          root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 5000, text: 'Test Account Reset', actionText: 'Go To Student Home', action: 'to:/' })
        })
      })
    }

    function copyUser () {
      trackerService.get(trackerId.value).then(async (data) => {
        delete data._id
        data.pidm = user.value.pidm
        data.preferred = user.value.preferred
        data.last = user.value.last
        data.username = user.value.username
        data.email = user.value.email
        data.isTest = true
        await trackerService.create(data)
        root.$store.dispatch('loadTracker')
        root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 5000, text: 'Account Copied to Test', actionText: 'Go To Student Home', action: 'to:/' })
      })
    }

    async function addAction (row) {
      const data = await root.$feathers.service('orientation/tracker').patch(trackerId.value, { $push: { actions: { ...row, added: new Date() } } })
      loadTrackerData(data)
    }

    async function restoreAction (title) {
      const data = await root.$feathers.service('orientation/tracker').patch(trackerId.value, { 'actions.$[el].dismissed': false }, { query: { arrayFilters: [{ 'el.title': title }] } })
      loadTrackerData(data)
    }

    return {
      user,
      students,
      trackerId,
      sectionCount,
      slideCount,
      selectedName,
      selectedPidm,
      selected,
      blockTracker,
      sectionDataLoaded,
      isLoaded,
      tab,
      sections,
      actions,
      groupedActions,
      allActions,
      availableActions,
      resetTestUser,
      copyUser,
      addAction,
      restoreAction,
      formatDuration,
      stringFormatDate
    }
  }
}
</script>
